import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

import * as yup from 'yup';

/** User login request body */
export interface UserLoginInterface {
  /** User email (login) */
  email: string;
  /** User password */
  password: string;
  /** Should we "remember" user (create long live JWT)? */
  remember?: boolean;
}

/** User login request body DTO schema */
export const UserLoginDto = SerdeDtoClass.create<UserLoginInterface>(SecurityDtoKeysEnum.USER_LOGIN_DTO, {
  email: {
    sortable: true,
    label: 'Email',
    serializer: yup
      .string()
      .email(DtoMessageEnum.INCORRECT_EMAIL),
  },
  password: {
    label: 'Пароль',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  remember: {
    optional: true,
    label: 'Запомнить пароль',
    serializer: yup.boolean(),
  },
});
